import React, { Fragment } from "react";
import { Divider } from "@theorgchartdev/storybook";
import * as StateLib from "@/Utils/StateLib";
import PhotoScalePopover from "@/appComponents/Blocks/Composites/PhotoScalePopover/PhotoScalePopover";
import { GetWSMgr } from "@/Utils/StateLib";
import { ObjectSpacingCompositePopover } from "@/appComponents/Navigation/ContextualToolbar/ObjectSpacingPopover/ObjectSpacingCompositePopover";
import { getHoverTipContent } from "@/Utils/Misc";
import { appstr } from "@coreapp/utils/appstr";
import { enumUpdateProperty } from "@coreapp/constants";

const handleArrange = target => {
  const wsMgr = StateLib.GetWSMgr();
  if (!wsMgr) return;
  wsMgr.Arrange(target.value);
  StateLib.ReRenderCanvas();
};

export const handlePin = option => {
  const wsMgr = StateLib.GetWSMgr();
  if (!wsMgr) return;
  wsMgr.StartCheckPoint();
  wsMgr.PositionSelectedTextBox(option.value);
  wsMgr.EndCheckPoint();
  StateLib.ReRenderCanvas();
};

const ArrangeToolsComposite = () => {
  const wsMgr = GetWSMgr();
  const backgroundMgr = wsMgr?.fBackgroundMgr;
  const enumUpdateKeys = {
    fTop: enumUpdateProperty.topMargin,
    fBottom: enumUpdateProperty.bottomMargin,
    fLeft: enumUpdateProperty.leftMargin,
    fRight: enumUpdateProperty.rightMargin
  };

  let isPicture = false;
  let firstSelectedTextBox = null;
  let userBoxSpacing = null;
  let currentLayout = null;

  if (wsMgr) {
    firstSelectedTextBox = wsMgr.GetFirstSelectedBox(true);
    isPicture = firstSelectedTextBox?.IsStaticPicture();
    userBoxSpacing = firstSelectedTextBox?.GetBoxMargins();
    currentLayout = firstSelectedTextBox?.GetLayout();
  }

  const updateSpacing = ({ spacing, updateKey }) => {
    const wsMgr = StateLib.GetWSMgr();
    if (!wsMgr) return;
    StateLib.UpdateBoxProperty(enumUpdateKeys[updateKey], spacing[updateKey]);
    StateLib.ReRenderCanvas();
  };

  const getSpacingInfo = () => {
    const layoutArea = backgroundMgr?.DetermineLayoutArea(currentLayout);

    const bottomArea = layoutArea?.toLowerCase()?.includes("bottom");
    const rightArea = layoutArea?.toLowerCase()?.includes("right");
    const vertKey = bottomArea ? "fBottom" : "fTop";
    const horzKey = rightArea ? "fRight" : "fLeft";
    const vertLabel = bottomArea
      ? appstr("Background bottom spacing")
      : appstr("Background top spacing");
    const horzLabel = rightArea
      ? appstr("Background right spacing")
      : appstr("Background left spacing");

    return { vertKey, horzKey, vertLabel, horzLabel };
  };

  const { vertKey, horzKey, vertLabel, horzLabel } = getSpacingInfo();

  return (
    <Fragment>
      {isPicture && (
        <PhotoScalePopover
          toolbarPopoverProps={{
            icon: "arrows-maximize",
            triggerTestId: "background-editor-toolbar-resize-image-btn",
            iconProps: { tooltipProps: { ...getHoverTipContent("Resize Image Tip") } }
          }}
          srcElement={firstSelectedTextBox}
        />
      )}
      <ObjectSpacingCompositePopover
        key={0}
        icon={"arrows-left-right-to-line"}
        triggerTestId="background-editor-toolbar-horizontal-spacing-btn"
        spacing={userBoxSpacing}
        setSpacing={updateSpacing}
        updateKey={horzKey}
        title={horzLabel}
        toolbarPopoverProps={{
          iconProps: {
            tooltipProps: { ...getHoverTipContent("Horizontal Spacing Tip") }
          }
        }}
      />
      <ObjectSpacingCompositePopover
        key={1}
        icon={"arrows-up-down-to-line"}
        triggerTestId="background-editor-toolbar-vertical-spacing-btn"
        spacing={userBoxSpacing}
        setSpacing={updateSpacing}
        updateKey={vertKey}
        title={vertLabel}
        toolbarPopoverProps={{
          iconProps: {
            tooltipProps: { ...getHoverTipContent("Vertical Spacing Tip") }
          }
        }}
      />
      <div className={"ocn-toolbar-horizontal-divider"}>
        <Divider vertical={true} />
      </div>
    </Fragment>
  );
};

export default ArrangeToolsComposite;
